import { render, staticRenderFns } from "./ImageModeButton.vue?vue&type=template&id=feb5a98a"
import script from "./ImageModeButton.vue?vue&type=script&lang=ts"
export * from "./ImageModeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports